<div class="reset-container">
    @if (token === undefined) {
        <form class="card" [formGroup]="sendPasswordResetForm">
            <div class="logo-container mb-6">
                <img class="logo" src="assets/logos/sewio_full.png" />
            </div>
            <div class="welcome-container mb-4">Forgot Your Password?</div>
            <div class="message-container mb-4">Enter your email address and we will send you instructions to reset your password.</div>
            <mat-form-field class="mb-2" appearance="fill" [hideRequiredMarker]="true">
                <mat-label>Email address</mat-label>
                <input type="email" matInput name="reset-password-email" formControlName="email" />
                @if (sendPasswordResetForm.controls['email'].hasError('required')) {
                    <mat-error> Not a valid email address. </mat-error>
                } @else {
                    @if (sendPasswordResetForm.controls['email'].hasError('email')) {
                        <mat-error> Not a valid email address. </mat-error>
                    }
                }
            </mat-form-field>
            <div class="forgot-container mb-4">
                <a href="" (click)="redirectToLogin($event)">Back to login</a>
            </div>
            <button mat-flat-button color="primary" [disabled]="!sendPasswordResetForm.valid" (click)="send()">Continue</button>
        </form>
    }
    @if (token !== undefined) {
        <form class="card" [formGroup]="resetPasswordForm">
            <div class="logo-container mb-6">
                <img class="logo" src="assets/logos/sewio_full.png" />
            </div>
            <div class="welcome-container mb-4">Set New Password</div>
            <div class="message-container mb-4">Enter your new password.</div>
            <mat-form-field class="mb-2" appearance="fill" [hideRequiredMarker]="true">
                <mat-label>Password</mat-label>
                <input type="password" matInput name="new-password" formControlName="password" />
                @if (resetPasswordForm.controls['password'].hasError('required')) {
                    <mat-error> Password is too short. (0 / 8)</mat-error>
                } @else {
                    @if (resetPasswordForm.controls['password'].hasError('minlength')) {
                        <mat-error>
                            Password is too short. ({{ resetPasswordForm.controls['password'].errors?.minlength.actualLength }} /
                            {{ resetPasswordForm.controls['password'].errors?.minlength.requiredLength }})</mat-error
                        >
                    } @else {
                        @if (resetPasswordForm.controls['password'].hasError('hasLowerCaseValidator')) {
                            <mat-error> No lowercase character in password. </mat-error>
                        } @else {
                            @if (resetPasswordForm.controls['password'].hasError('hasNumberValidator')) {
                                <mat-error> No number in password. </mat-error>
                            }
                        }
                    }
                }
            </mat-form-field>
            <mat-form-field class="mb-2" appearance="fill" [hideRequiredMarker]="true">
                <mat-label>Confirm Password</mat-label>
                <input type="password" matInput name="new-password-confirm" formControlName="passwordConfirmation" />
                @if (resetPasswordForm.controls['passwordConfirmation'].hasError('passwordsMatchValidator')) {
                    <mat-error> Passwords do not match. </mat-error>
                }
            </mat-form-field>
            <div class="forgot-container mb-4">
                <a href="" (click)="redirectToLogin($event)">Back to login</a>
            </div>
            <button mat-flat-button color="primary" [disabled]="!resetPasswordForm.valid" (click)="reset()">Continue</button>
        </form>
    }
</div>
